import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false
import VueMasonry from 'vue-masonry-css'

Vue.use(VueMasonry);
new Vue({
  render: h => h(App),
}).$mount('#app')
